import Icon from "assets/icons";
import classNames from "classnames";
import React from "react";
import Variant from "shared/enums/Variant";
import { EmailLinkConfig } from "./types";

function EmailLinkClient({ variant = Variant.PRIMARY, ...props }: EmailLinkConfig) {
  const computedClassNames = React.useMemo(
    () => getClassNames(props.asButton, variant, props.isOutline),
    [props.asButton, variant, props.isOutline]
  );

  const emailLink = React.useMemo(() => {
    const queryParamsList = [];
    props.emailCC && queryParamsList.push(`cc=${props.emailCC}`);
    props.emailBCC && queryParamsList.push(`bcc=${props.emailBCC}`);
    props.subject && queryParamsList.push(`subject=${props.subject}`);
    return `mailto:${props.email}?${queryParamsList.join("&")}`;
  }, [props.email, props.emailCC, props.emailBCC, props.subject]);

  return (
    <a
      href={emailLink}
      target="_blank"
      rel="noopener noreferrer"
      onClick={props.onClick}
      title={props.email}
      className={classNames(computedClassNames, props.className)}>
      {props.icon ? <Icon.EmailEnvolope /> : props.email}
    </a>
  );
}

export default EmailLinkClient;

function getClassNames(asButton?: boolean, variant?: Variant, isOutline?: boolean) {
  return classNames({
    link: true,
    "link--asBtn": asButton,
    [`link--asBtn--${variant}`]: asButton && variant,
    [`link--asBtn--${variant}--isOutlined`]: asButton && isOutline
  });
}
